import axios from "axios";
import {
  user_signup_fail,
  user_signup_request,
  user_signup_sucess,
  user_login_fail,
  user_login_request,
  user_login_sucess,
  registerd_user_request,
  registerd_user_sucess,
  registerd_user_fail,
  get_user_request,
  get_user_sucess,
  get_user_fail,
  user_logout_request,
  user_logout_sucess,
  user_logout_fail,
  allow_user_request,
  allow_user_sucess,
  allow_user_fail,
  delete_user_request,
  delete_user_sucess,
  delete_user_fail,
  send_otp_request,
  send_otp_sucess,
  send_otp_fail,
  verify_otp_request,
  verify_otp_sucess,
  verify_otp_fail,
  resend_otp_request,
  resend_otp_sucess,
  resend_otp_fail,
  load_user_request,
  load_user_sucess,
  load_user_fail,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCESS,
  FORGOT_PASSWORD_FAIL,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCESS,
  RESET_PASSWORD_FAIL,
} from "../constants/dataConstants";

axios.defaults.baseURL =process.env.NODE_ENV==="production"? process.env.REACT_APP_SERVER_URL:"http://localhost:8000";
axios.defaults.withCredentials = true;
export const userSignup = (data) => async (dispatch) => {
  const { firstName, lastName, email, phoneNumber, userLevel } = data;
  try {
    dispatch({ type: user_signup_request });
    const { data } = await axios.post(
      `/sign-up`,
      { firstName, lastName, email, phoneNumber, userLevel: userLevel },
      { withCredentials: true }
    );
    dispatch({ type: user_signup_sucess, payload: data.sucess });
  } catch (error) {
    dispatch({
      type: user_signup_fail,
      payload: error?.response?.data?.error || error.message,
    });
  }
};

export const userLogin = (data) => async (dispatch) => {
  const { userName, password } = data;
  try {
    dispatch({ type: user_login_request });

    const { data } = await axios.post(
      `/login`,
      {
        userName: userName?.trim(),
        password: password?.trim(),
        // userName,
        // password
      },
      { withCredentials: true }
    );

    dispatch({
      type: user_login_sucess,
      payload: data?.sucess,
    });
  } catch (error) {
    dispatch({
      type: user_login_fail,
      payload: error?.response?.data?.error || error?.message,
    });
  }
};

export const userLogout = () => async (dispatch) => {
  try {
    dispatch({ type: user_logout_request });
    const { data } = await axios.post(`/logout`);

    dispatch({ type: user_logout_sucess, payload: data?.sucess });
  } catch (error) {
    dispatch({
      type: user_logout_fail,
      payload: error?.response?.data?.error || error.message,
    });
  }
};

export const getUser = () => async (dispatch) => {
  try {
    dispatch({ type: get_user_request });
    const { data } = await axios.get(`/getuser`);
    dispatch({ type: get_user_sucess, payload: data.user });
  } catch (error) {
    dispatch({ type: get_user_fail, payload: error?.response?.data?.error });
  }
};

export const loadUser = () => async (dispatch) => {
  try {
    dispatch({ type: load_user_request });
    const { data } = await axios.get(`/getuser`);
    dispatch({ type: load_user_sucess, payload: data.user });
  } catch (error) {
    dispatch({ type: load_user_fail, payload: error?.response?.data?.error });
  }
};

export const registredUsers = () => async (dispatch) => {
  try {
    dispatch({ type: registerd_user_request });

    const { data } = await axios.get(`/admin/registered-users`);
    dispatch({ type: registerd_user_sucess, payload: data.users });
  } catch (error) {
    dispatch({
      type: registerd_user_fail,
      payload: error?.response?.data?.error || error.message,
    });
  }
};

export const allowUser = (email_ID) => async (dispatch) => {
  try {
    dispatch({ type: allow_user_request });

    const { data } = await axios.post(`/admin/allow-user`, { email_ID });
    dispatch({ type: allow_user_sucess, payload: data.sucess });
  } catch (error) {
    dispatch({
      type: allow_user_fail,
      payload: error?.response?.data?.error || error.message,
    });
  }
};

export const deleteUser = (email_ID) => async (dispatch) => {
  try {
    dispatch({ type: delete_user_request });

    const { data } = await axios.delete(`/admin/delete-user/${email_ID}`);
    dispatch({ type: delete_user_sucess, payload: data.sucess });
  } catch (error) {
    dispatch({
      type: delete_user_fail,
      payload: error?.response?.data?.error || error.message,
    });
  }
};

export const sendOtp = (email_ID) => async (dispatch) => {
  try {
    dispatch({ type: send_otp_request });

    const { data } = await axios.post(`/send-otp`, { email_ID });
    dispatch({ type: send_otp_sucess, payload: data.sucess });
  } catch (error) {
    dispatch({
      type: send_otp_fail,
      payload: error?.response?.data?.error || error.message,
    });
  }
};

export const ResendOtp = (email_ID) => async (dispatch) => {
  try {
    dispatch({ type: resend_otp_request });

    const { data } = await axios.post(`/resend-otp`, { email_ID });
    dispatch({ type: resend_otp_sucess, payload: data.sucess });
  } catch (error) {
    dispatch({
      type: resend_otp_fail,
      payload: error?.response?.data?.error || error.message,
    });
  }
};

export const verifyOtp = (otp, email_ID) => async (dispatch) => {
  try {
    dispatch({ type: verify_otp_request });

    const { data } = await axios.post(`/verify-otp`, { otp, email_ID });
    dispatch({ type: verify_otp_sucess, payload: data.sucess });
  } catch (error) {
    dispatch({
      type: verify_otp_fail,
      payload: error?.response?.data?.error || error.message,
    });
  }
};


// Forgot Password
  export const forgotPassword = (email) => async (dispatch) => {
    try {
      dispatch({ type: FORGOT_PASSWORD_REQUEST });
  
  
      const { data } = await axios.post(`/password/forgot`,{ email});
  
      dispatch({ type: FORGOT_PASSWORD_SUCESS, payload: data.sucess });
    } catch (error) {
      dispatch({
        type: FORGOT_PASSWORD_FAIL,
        payload: error.response.data?.error,
      });
    }
  };
  
  // Reset Password
  export const resetPassword = (token, passwords) => async (dispatch) => {
    try {
      console.log(token,passwords)
      dispatch({ type: RESET_PASSWORD_REQUEST });
  
  
      const { data } = await axios.put(
        `/password/reset/${token}`,
       {... passwords}
      );
      dispatch({ type: RESET_PASSWORD_SUCESS, payload: data.sucess });
    
    } catch (error) {

        dispatch({
        type: RESET_PASSWORD_FAIL,
        payload: error.response.data?.error,
      });
      
    }
  };
